// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aw","header":"ax","title":"ay","description":"az","subHeader":"aA","button":"aB"};